module.exports = __webpack_public_path__ + "img/hilfe_handschrift_anim.bebe2899.png";